const $menuIcon = qs('.headerMenu');
const $menu = qs('.CP-header__menu');
const $nav = qs('.CP-header nav');
const $search = qs('.CP-search');
const $loop = qs('.headerSearch');
const $overlay = qs('.overlay');


ready(qs('.CP-header'), () => {
    ael($menuIcon, 'click', () => {
        $menu.classList.toggle('CP-header__menu--hidden');
        $nav.classList.toggle('CP-header__nav--hidden');
    })
    ael($loop, 'click', () => {
        $search.classList.toggle('CP-search--active');
        $overlay.classList.toggle('overlay--active');
    })
    ael($overlay, 'click', () => {
        $search.classList.remove('CP-search--active');$overlay.classList.remove('overlay--active');
    })
})


// WEBPACK FOOTER //
// ./src/scripts/components/Header.js